"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeLogger = void 0;
var _exenv = require("exenv");
var _config = _interopRequireDefault(require("./config"));
var _ClientConsoleStream = _interopRequireDefault(require("./logger/browser/ClientConsoleStream"));
var _ClientPushStream = _interopRequireDefault(require("./logger/browser/ClientPushStream"));
var _transform = require("./logger/transform");
var _NuiTransport = require("./NuiTransport");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('winston'),
  createLogger = _require.createLogger,
  transports = _require.transports,
  format = _require.format;
require('setimmediate');

/** makeTransports acts
 * like a factory for creating transports for
 * winston.
 */
var makeTransports = function makeTransports(level) {
  var transports = [];
  if (_exenv.canUseDOM) {
    transports.push(new _NuiTransport.NuiTransport({
      level: 'info',
      stream: new _ClientPushStream.default({
        url: "".concat(_config.default.nui.baseUrl, "/nui-shell/api/logs")
      })
    }));

    // Log to console if NUI_LOG_USEBROWSERCONSOLE is true
    if (_config.default.nui.log.useBrowserConsole) {
      transports.push(new _NuiTransport.NuiTransport({
        level: 'info',
        stream: new _ClientConsoleStream.default({
          verbose: _config.default.nui.log.verbose,
          config: _config.default
        })
      }));
    }
  } else if (typeof __DEVTOOLS__ !== 'undefined' && __DEVTOOLS__ || process.env.NODE_ENV === 'development') {
    transports.push(new _NuiTransport.NuiTransport({
      level: level,
      stream: new _ClientConsoleStream.default({
        verbose: _config.default.nui.log.verbose
      })
    }));
  } else {
    // for non-dev mode push to stdout
    transports.push(new _NuiTransport.NuiTransport({
      level: level,
      name: 'process.stdout',
      stream: process.stdout
    }));
  }
  return transports;
};

/** makeLogger acts
 * like a factory for creating complaint
 * loggers. When the underlying implementation
 * (winston) changes/is replaced,
 * update the factory.
 */
var makeLogger = exports.makeLogger = function makeLogger(_ref) {
  var level = _ref.level,
    defaultMeta = _ref.defaultMeta,
    useFormat = _ref.useFormat,
    customTransformer = _ref.customTransformer,
    validateFn = _ref.validateFn;
  var transports = makeTransports(level);
  var formatOverride = typeof customTransformer === 'function' ? {
    format: format.combine(format(function (record, opts) {
      return customTransformer(record);
    })())
  } : {};
  return {
    logger: createLogger(_objectSpread(_objectSpread({
      level: level,
      format: useFormat ? format.combine((0, _transform.transform)({
        validateFn: validateFn
      })) : undefined
    }, formatOverride), {}, {
      transports: transports,
      defaultMeta: defaultMeta
    })),
    streams: transports
  };
};